const fractionalDollarFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
const wholeDollarFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});
const wholeNumberFormatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});
const fractionalNumberFormatter = new Intl.NumberFormat("en-US");
export function addThousandComma(numberAsText) {
    const minSeparatorLen = 3;
    const delimiter = ",";
    const thousandsInNumber = Math.floor((numberAsText.length - 1) / minSeparatorLen);
    let result = numberAsText;
    if (thousandsInNumber <= 0) {
        return numberAsText;
    }
    for (let i = 1; i <= thousandsInNumber; i++) {
        result = [
            result.slice(0, -i * minSeparatorLen - (i - 1)),
            delimiter,
            result.slice(-i * minSeparatorLen - (i - 1)),
        ].join("");
    }
    return result;
}
export function formatValue(value, maxValue = undefined, noCurrency = false) {
    const money = noCurrency ? value : "$" + addThousandComma(value.toString());
    return value === maxValue ? money + "+" : money.toString();
}
export function formatNumber(value) {
    if (value === null || value === undefined)
        return "";
    if (Math.floor(value) === value) {
        return wholeNumberFormatter.format(value);
    }
    return fractionalNumberFormatter.format(value);
}
export function formatNumberRange(valueLow, valueHigh) {
    if (valueLow && valueHigh) {
        return `${formatNumber(valueLow)} - ${formatNumber(valueHigh)}`;
    }
    if (valueHigh) {
        return formatNumber(valueHigh);
    }
    if (valueLow) {
        return formatNumber(valueLow);
    }
    return "";
}
export function formatCurrency(value) {
    if (value === null || value === undefined)
        return "";
    const numericalValue = typeof value === "number" ? value : parseFloat(value);
    if (Math.floor(numericalValue) === numericalValue) {
        return wholeDollarFormatter.format(numericalValue);
    }
    return fractionalDollarFormatter.format(numericalValue);
}
export function formatCurrencyRange(valueLow, valueHigh) {
    if (valueLow && valueHigh) {
        return `${formatCurrency(valueLow)} - ${formatCurrency(valueHigh)}`;
    }
    if (valueHigh) {
        return formatCurrency(valueHigh);
    }
    if (valueLow) {
        return formatCurrency(valueLow);
    }
    return "";
}
export function formatStringValue(value) {
    try {
        if (!value || value === "" || (value && !value.length)) {
            return "";
        }
        const valueNumber = clearFormatting(value);
        const valueFixed = addSeparators(valueNumber);
        return `$${valueFixed}`;
    }
    catch (e) {
        console.error({ message: "Caught an error!", e, value });
        throw e;
    }
}
export function clearFormatting(formattedText) {
    const replacedText = formattedText.replace(/^\$\s*/, "").replace(/,/g, "");
    const asNumber = parseFloat(replacedText);
    if (isNaN(asNumber)) {
        return "";
    }
    return asNumber.toString();
}
function isFloatingNumber(numberAsText) {
    return numberAsText.indexOf(".") > -1;
}
function addSeparators(numberAsText) {
    const decimalSeparator = ".";
    if (!isFloatingNumber(numberAsText)) {
        return addThousandComma(numberAsText);
    }
    const [intPart, fractionPart] = Number(numberAsText)
        .toFixed(2)
        .split(decimalSeparator);
    return addThousandComma(intPart) + decimalSeparator + fractionPart;
}
/**
 * Returns a string representing value.
 * Does not include commas or dollar signs.
 * If value is undefined, returns an empty string.
 * If amount is evenly divisible by 100 (i.e. no cents), returns a whole number represntation with no decimal place.
 * @param valueInCents value to be converted to string
 */
export const currencyInCentsToString = (value) => {
    if (value === undefined)
        return "";
    if (value === 0)
        return "0";
    let result = value.toString();
    if (result.endsWith("00")) {
        return result.slice(0, -2);
    }
    result = result.slice(0, -2) + "." + result.slice(-2);
    if (result.startsWith(".")) {
        result = "0" + result;
    }
    return result;
};
/**
 * Returns a number representing value.
 * If value is undefined, returns 0.
 * @param valueInCents value to be converted to number. If value is numeric, will do our best to convert it. However, passing a string is preferred.
 */
export const stringToCurrencyInCents = (value) => {
    if (!value) {
        return 0;
    }
    if (typeof value !== "string") {
        value = value.toString();
    }
    value = value.replace(/[^0-9.-]/g, "");
    if (!value) {
        return 0;
    }
    if (value.includes(".")) {
        const decimalIndex = value.indexOf(".");
        const dollars = value.slice(0, decimalIndex);
        let rest = value.slice(decimalIndex + 1);
        rest = (rest.replace(/[^0-9]/g, "") + "00").slice(0, 2);
        return parseInt(`${dollars}${rest}`, 10);
    }
    else {
        return parseInt(`${value}00`, 10);
    }
};
export function safeParseCurrency(value) {
    if (value === null || value === undefined)
        return null;
    if (typeof value === "number") {
        return isNaN(value) ? null : value;
    }
    const trimmed = value.trim();
    if (!trimmed)
        return null;
    const cleaned = trimmed.replace(/[$,]/g, "").trim();
    if (!cleaned)
        return null;
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
}
//# sourceMappingURL=currency.js.map